import { lazy, Suspense } from 'react';
import { Outlet, Navigate, useRoutes } from 'react-router-dom';

import { MainLayout } from 'src/layouts/main';

import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// Blog
const BlogPostsPage = lazy(() => import('src/pages/post/list'));
const BlogPostPage = lazy(() => import('src/pages/post/details'));

const HomePage = lazy(() => import('src/pages/home'));

export function Router() {
  return useRoutes([
    // {
    //   path: '/',
    //   /**
    //    * Skip home page
    //    * element: <Navigate to={CONFIG.auth.redirectPath} replace />,
    //    */
    //   element: (
    //     <Suspense fallback={<SplashScreen />}>
    //       <MainLayout>
    //         <HomePage />
    //       </MainLayout>
    //     </Suspense>
    //   ),
    // },

    {
      path: '',
      element: (
        <Suspense fallback={<SplashScreen />}>
          <MainLayout>
            <Outlet />
          </MainLayout>
        </Suspense>
      ),
      children: [
        { path: '', element: <BlogPostsPage />, index: true },
        { path: ':title', element: <BlogPostPage /> },
      ],
    },

    // // Auth
    // ...authRoutes,
    // ...authDemoRoutes,

    // // Dashboard
    // ...dashboardRoutes,

    // // Main
    // ...mainRoutes,

    // // Components
    // ...componentsRoutes,

    // No match
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
